/* Home carousel: tabs, arrows. No fetch, no dependencies. */
(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-hc-ready')) return;
    root.setAttribute('data-hc-ready', '1');

    var track = root.querySelector('[data-hc-track]');
    var rail = root.querySelector('.hc-rail');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.hc-tab'));
    var prev = root.querySelector('[data-hc-prev]');
    var next = root.querySelector('[data-hc-next]');
    var viewAll = root.querySelector('[data-hc-viewall]');
    if (!track || !tabs.length) return;

    var panels = {};
    var first = document.createElement('template');
    Array.prototype.forEach.call(track.children, function (n) {
      first.content.appendChild(n.cloneNode(true));
    });
    panels[0] = first;
    Array.prototype.forEach.call(root.querySelectorAll('template[data-tab-panel]'), function (t) {
      panels[t.getAttribute('data-tab-panel')] = t;
    });

    var ticking = false;

    function updateArrows() {
      ticking = false;
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth;
      prev.setAttribute('aria-disabled', track.scrollLeft <= 1 ? 'true' : 'false');
      next.setAttribute('aria-disabled', track.scrollLeft >= max - 1 ? 'true' : 'false');
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateArrows);
      }
    }

    function select(index, focus) {
      var tab = tabs[index];
      var panel = panels[index];
      if (!tab || !panel) return;
      tabs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      while (track.firstChild) track.removeChild(track.firstChild);
      track.appendChild(panel.content.cloneNode(true));
      track.scrollLeft = 0;
      if (rail) rail.setAttribute('aria-labelledby', tab.id);
      if (viewAll) {
        var href = tab.getAttribute('data-href');
        if (href) {
          viewAll.setAttribute('href', href);
          viewAll.hidden = false;
        } else {
          viewAll.hidden = true;
        }
      }
      track.classList.remove('hc-in');
      void track.offsetWidth;
      track.classList.add('hc-in');
      if (focus) tab.focus();
      updateArrows();
      // Abra (promotions app) re-decorates prices on this event; the old carousel's tab buttons fired it too.
      window.setTimeout(function () { window.dispatchEvent(new CustomEvent('abra:render')); }, 500);
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var to = -1;
        if (e.key === 'ArrowRight') to = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') to = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = tabs.length - 1;
        if (to > -1) {
          e.preventDefault();
          select(to, true);
        }
      });
    });

    function scrollByPage(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
    if (next) next.addEventListener('click', function () { scrollByPage(1); });

    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    updateArrows();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-home-carousel]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
